import React, { useEffect, useState, useCallback } from "react";
import {
  Col,
  Row,
  Card,
  CardBody,
  Button,
  InputGroup,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { Triangle } from "react-loader-spinner";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import CustomerServices from "../../../services/OrderingServices/CustomerServices";
import CustomerForm from "../Components/CustomerForm";
import DeleteModal from "../../../Components/Common/DeleteModal";
import MobileCustomerForm from "../Components/MobileCustomerForm";
import e from "cors";

const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};

const Customers = () => {
  const [customerList, setCustomerList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState();
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false);
  const [openDropdownId, setOpenDropdownId] = useState(null);

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "75px",
    },
    {
      name: "Name",
      selector: (row) => `${row.firstName} ${row.lastName}`,
      cell: (row) => (
        <Link to={`/customer/${row?.id}`}>
          {row.firstName} {row.lastName}
        </Link>
      ),
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Phone No",
      selector: (row) => row.phoneNo,
      sortable: true,
    },
    {
      name: "Customer Type",
      selector: (row) => row.customerTypeName,
      sortable: true,
    },
    {
      name: "Discount (%)",
      selector: (row) => row.customerTypeDiscount,
      sortable: true,
      right: true,
    },

    {
      name: "Action",
      selector: (row) => (
        <div>
          <Button
            color="btn btn-soft-warning"
            className="btn-sm ms-1"
            onClick={() => {
              setAddModal(true);
              setSelectedCustomer(row);
            }}
          >
            <i className="ri-edit-line" />
          </Button>
          <Button
            className="btn btn-soft-danger btn-sm ms-1"
            color="danger"
            onClick={() => handleDeleteClick(row.id)}
          >
            <i className="ri-delete-bin-5-line" />
          </Button>
        </div>
      ),
      center: true,
    },
  ];

  const fetchCustomers = async () => {
    try {
      setLoading(true);
      const response = await CustomerServices.getCustomerList();

      setCustomerList(response);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("🚀 ~ error:", error);
    }
  };

  // Fetch customers when debounced filters, current page or page size changes
  useEffect(() => {
    fetchCustomers();
  }, []);
  const [filterText, setFilterText] = useState("");

  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };

  const filteredData = customerList.filter((pkg) => {
    // console.log("🚀 ~ filteredPackages ~ pkg:", pkg);

    // Combine name, surname, email, and phone number into a single search context, handling undefined fields
    const searchContext = `${pkg?.firstName || ""} ${pkg?.lastName || ""} ${
      pkg?.phoneNo || ""
    }`.toLowerCase();

    // Check if the filterText is included in any of the search context
    const matchesFilter = searchContext.includes(filterText.toLowerCase());

    return matchesFilter;
  });
  const toggleDeleteModal = () => setDeleteModal(!deleteModal);
  const handleDeleteClick = (item) => {
    setSelectedCustomer(item);
    toggleDeleteModal();
  };
  const handleDelete = async () => {
    if (selectedCustomer) {
      try {
        await CustomerServices.delete(selectedCustomer);
        setCustomerList((prevList) =>
          prevList.filter((pkg) => pkg.id !== selectedCustomer)
        );
        toast.success("Selected customer deleted successfully");
      } catch (error) {
        toast.error("Failed to delete the record");
      } finally {
        toggleDeleteModal();
        setSelectedCustomer(null);
      }
    }
  };
  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Customer List" pageTitle="Customer" />
      </div>
      <Row>
        <Col md={8} xs={10} className="mb-2">
          <InputGroup>
            <Input
              placeholder="Search by name and phone number"
              value={filterText}
              onChange={handleFilterChange}
            />
          </InputGroup>
        </Col>
        <Col
          md={4}
          xs={12}
          className="d-lg-flex d-none justify-content-end align-items-end mb-2"
        >
          <button
            className="btn btn-success px-1 px-sm-2"
            onClick={() => setAddModal(true)}
          >
            + Add Customer
          </button>
        </Col>
        <Col
          md={4}
          xs={2}
          className="d-flex d-lg-none justify-content-end align-items-end mb-2"
        >
          <button
            className="btn btn-success  "
            onClick={() => setAddModal(true)}
          >
            +
          </button>
        </Col>
      </Row>
      <Card className="d-none d-lg-block">
        <CardBody>
          <CustomDataTable
            responsive
            striped
            pagination
            fixedHeader
            persistTableHead
            progressPending={loading}
            customStyles={customStyles}
            progressComponent={
              <div className="my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
            columns={columns}
            data={filteredData}
          />
        </CardBody>
      </Card>
      {loading ? (
        <div className="my-5 d-flex d-lg-none d-md-none justify-content-center">
          <Triangle
            visible={true}
            height="60"
            width="60"
            color="#5B71B9"
            ariaLabel="triangle-loading"
          />
        </div>
      ) : (
        <>
          {filteredData?.map((item, index) => (
            <Card
              key={item.id || index}
              className="mb-3 shadow-sm d-block d-lg-none mt-2"
              onClick={(e) => {
                e.stopPropagation(); // prevents parent click handlers
                navigate(`/customer/${item?.id}`);
              }}
            >
              <CardBody>
                <Row>
                  <Col xs={10}>
                    <h6 className="mb-2">{`${item.firstName} ${item.lastName}`}</h6>
                    <h6 className="mb-2 text-muted">{item?.email}</h6>
                    <h6 className="mb-2">{item?.phoneNo}</h6>
                    <h6 className="mb-2">
                      <strong>Type:</strong> {item?.customerTypeName || "none"}
                    </h6>
                    <h6 className="mb-0">
                      <strong>Discount:</strong>{" "}
                      {item?.customerTypeDiscount || 0} %
                    </h6>
                  </Col>
                  <Col xs={2}>
                    <div>
                      <Dropdown
                        isOpen={item.dropdownOpen || false}
                        toggle={(e) => {
                          e.stopPropagation(); // prevents parent click handlers

                          setCustomerList((prev) =>
                            prev.map(
                              (customer) =>
                                customer.id === item.id
                                  ? {
                                      ...customer,
                                      dropdownOpen: !customer.dropdownOpen,
                                    }
                                  : { ...customer, dropdownOpen: false } // close all others
                            )
                          );
                        }}
                        direction="down"
                      >
                        <DropdownToggle
                          color="primary"
                          outline
                          className="btn-sm  shadow-sm rounded-circle"
                        >
                          <i className="ri-more-2-fill"></i>
                        </DropdownToggle>
                        <DropdownMenu end>
                          <DropdownItem
                            onClick={() => {
                              setAddModal(true);
                              setSelectedCustomer(item);
                            }}
                          >
                            <i className="ri-edit-line text-warning me-2"></i>{" "}
                            Edit
                          </DropdownItem>
                          <DropdownItem
                            onClick={() => handleDeleteClick(item.id)}
                          >
                            <i className="ri-delete-bin-5-line text-danger me-2"></i>{" "}
                            Delete
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          ))}
        </>
      )}

      <MobileCustomerForm
        modal={addModal}
        toggleModal={() => {
          setAddModal(false);
          setSelectedCustomer(null); // Clear editing state when closing
        }}
        setCustomerList={setCustomerList}
        customerList={customerList}
        selectedCustomer={selectedCustomer}
        fetchCustomers={fetchCustomers}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={toggleDeleteModal}
        selectedItem={selectedCustomer} // Pass the selected item
      />
    </div>
  );
};

export default Customers;
